import { getTargets } from 'src/scripts/utils/utils'
import { FloatElementBtn } from '.'
import { isTabKey } from 'src/scripts/utils/key'
import { HeaderComponent } from 'src/scripts/sections/header'

export class HeaderFloatElementBtn extends FloatElementBtn {
  floatElementContainerId: string
  floatElementId: string
  isFocused: boolean

  constructor() {
    super()

    this.floatElementContainerId = this.dataset.floatElementId
    this.element = this.firstElementChild
    this.floatElementId = this.element.dataset.headerFloatElementTrigger
  }

  handleMouseLeave = (event): void => {
    event.stopPropagation()
  }

  handleMouseEnter = (event): void => {
    event.stopPropagation()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isTabKey(event) && !event.shiftKey) {
      event.preventDefault()
      this.emit('focused', { button: this })

      if (!this.isOpen) {
        const header: HeaderComponent = this.closest('header-component')
        header.handleButtonHover(this)
        this.setExpand(true)

        return
      }

      const { targets, lastTarget } = getTargets(
        this.floatElement.currentVisible,
        false,
      )
      const firstTarget = targets.find(el => !el.hasAttribute('disabled'))

      if (firstTarget && !this.isFocused) {
        this.addListener(lastTarget, 'blur', this.handleLastTargetBlur)
        firstTarget.focus()
        this.isFocused = true
      }
    }
  }

  handleLastTargetBlur = ({ currentTarget }): void => {
    const header: HeaderComponent = this.closest('header-component')
    header.handleMouseLeave()

    let nextToFocus: HTMLElement

    if (this.hasAttribute('data-is-last-menu-item')) {
      nextToFocus = getTargets(
        header.navContainer.nextElementSibling,
      ).firstTarget
    } else {
      nextToFocus = this.nextElementSibling?.hasAttribute('href')
        ? (this.nextElementSibling as HTMLElement)
        : (this.nextElementSibling.firstElementChild as HTMLElement)
    }

    nextToFocus?.focus()

    this.setExpand(false)
    this.isFocused = false

    this.removeListener(currentTarget, 'blur', this.handleLastTargetBlur)
  }

  handleBlur = (): void => {
    this.emit('blured', { button: this })
  }

  trigger = (): void => {}

  setExpand(isExpanded): void {
    this.setAttribute('data-aria-expanded', isExpanded)
  }

  get isOpen(): boolean {
    return this.dataset.ariaExpanded === 'true'
  }
}
